import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import countryList from "react-select-country-list";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import PhoneInputDropdown from "./PhoneInputDropdown";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Form, Input, Radio, Icon, Select, Row, Col, Button } from "antd";
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import {
  radioStyle,
  labelStyle,
  buttonStyle,
  formSubmissionErrorStyle,
} from "./styles";

const { Option } = Select;

const errorDivRef = React.createRef();

class CustomerForm extends React.Component {
  state = {
    token: {},
    isFormSubmissionError: false,
  };

  formRef = React.createRef();

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.props.saveBookingFormInfo(values);
        this.setState({ isFormSubmissionError: false });
        this.props.onSubmit();
      } else {
        this.setState({ isFormSubmissionError: true });
        if (errorDivRef.current) {
          errorDivRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  };

  // Custom validation function using libphonenumber-js
  validatePhoneNumber = (rule, value) => {
    if (!value) {
      return Promise.reject('Phone number is required!');
    }

    const phoneNumber = parsePhoneNumberFromString(value);
    
    if (!phoneNumber || !phoneNumber.isValid()) {
      return Promise.reject('Invalid phone number!');
    }

    return Promise.resolve();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { transaction_type } = this.props;
    const { booking_customer_form } = this.props;

    const options = countryList().getData();
    return (
      <div style={{ backgroundColor: "white" }}>
        <div
          ref={errorDivRef}
          style={{
            paddingTop: "1rem",
            backgroundColor: "white",
          }}
        >
          <Row type="flex" justify="center">
            <Col xs={20} sm={20} md={16} lg={12}>
              {this.state.isFormSubmissionError ? (
                <div style={formSubmissionErrorStyle}>
                  <Icon
                    type="exclamation-circle"
                    style={{ fontSize: "20px", color: "#790000" }}
                    theme="outlined"
                  />
                  &nbsp;
                  <span>
                    There was a problem with your submission. Please review the
                    fields below.
                  </span>
                </div>
              ) : (
                ""
              )}

              <Form //{...formItemLayout}
                ref={this.formRef}
                onSubmit={this.handleSubmit}
                className="booking-form"
                autoComplete="off"
              >
                <Row>
                  <Form.Item
                    label={
                      <span style={labelStyle}>
                        What is your role in this transaction
                      </span>
                    }
                  >
                    {getFieldDecorator("customer_type", {
                      initialValue: transaction_type || booking_customer_form?.customer_type,
                      rules: [
                        {
                          required: true,
                          message: "Please input customer type",
                        },
                      ],
                    })(
                      <Radio.Group
                        name="customer_type"
                        onChange={this.handleChange}
                      >
                        <Radio style={radioStyle} value={"Importer"}>
                          Importer / Receiver
                        </Radio>
                        <Radio style={radioStyle} value={"Exporter"}>
                          Exporter / Shipper
                        </Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Row>
            {/* } */}
                <Row
                  type="flex"
                  md={{ justify: "space-between" }}
                  xs={{ justify: "center" }}
                  sm={{ justify: "center" }}
                  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
                >
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={<span style={labelStyle}>First Name</span>}
                    >
                      {getFieldDecorator("customer_first_name", {
                        initialValue: booking_customer_form?.customer_first_name,
                        rules: [
                          {
                            required: true,
                            message: "Please input first name",
                          },
                        ],
                      })(<Input size="large" placeholder="First Name" />)}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      label={<span style={labelStyle}>Last Name</span>}
                    >
                      {getFieldDecorator("customer_last_name", {
                        initialValue: booking_customer_form?.customer_last_name,
                        rules: [
                          {
                            required: true,
                            message: "Please input last name",
                          },
                        ],
                      })(<Input size="large" placeholder="Last Name" />)}
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  type="flex"
                  md={{ justify: "space-between" }}
                  xs={{ justify: "center" }}
                  sm={{ justify: "center" }}
                  gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
                >
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item label={<span style={labelStyle}>E-mail</span>}>
                      {getFieldDecorator("email", {
                        initialValue: booking_customer_form?.email,
                        rules: [
                          {
                            type: "email",
                            message: "The input is not valid E-mail!",
                          },
                          {
                            required: true,
                            message: "E-mail is required",
                          },
                        ],
                      })(<Input size="large" />)}
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="phone"
                      label={<span style={labelStyle}>Phone</span>}
                    >
                      {getFieldDecorator("phone", {
                        initialValue: booking_customer_form?.phone,
                        rules: [
                          {
                            validator: this.validatePhoneNumber,
                          },
                        ],
                      })(<PhoneInputDropdown />)}
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item label={<span style={labelStyle}>Company Name</span>}>
                  {getFieldDecorator("company_name", {
                    initialValue: booking_customer_form?.company_name,
                    rules: [
                      {
                        required: true,
                        message: "Please input your company name!",
                      },
                    ],
                  })(<Input size="large" />)}
                </Form.Item>

                <Form.Item label={<span style={labelStyle}>Address</span>}>
                  <Form.Item>
                    {getFieldDecorator("street", {
                      initialValue: booking_customer_form?.street,
                      rules: [{ required: false }],
                    })(<Input size="large" placeholder="Street Address" />)}
                  </Form.Item>

                  <Form.Item>
                    {getFieldDecorator("address", {
                      initialValue: booking_customer_form?.address,
                      rules: [{ required: false }],
                    })(<Input size="large" placeholder="Address Line 2" />)}
                  </Form.Item>

                  <Row
                    type="flex"
                    md={{ justify: "space-between" }}
                    xs={{ justify: "center" }}
                    sm={{ justify: "center" }}
                    gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
                  >
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item>
                        {getFieldDecorator("city", {
                          initialValue: booking_customer_form?.city,
                          rules: [{ required: false }],
                        })(<Input size="large" placeholder="City" />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item>
                        {getFieldDecorator("state", {
                          initialValue: booking_customer_form?.state,
                          rules: [{ required: false }],
                        })(
                          <Input size="large" placeholder="State / Province" />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    type="flex"
                    md={{ justify: "space-between" }}
                    xs={{ justify: "center" }}
                    sm={{ justify: "center" }}
                    gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
                  >
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item>
                        {getFieldDecorator("postal", {
                          initialValue: booking_customer_form?.postal,
                          rules: [{ required: false }],
                        })(
                          <Input size="large" placeholder="ZIP / Postal Code" />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item>
                        {getFieldDecorator("country", {
                          initialValue: booking_customer_form?.country || undefined,
                          rules: [
                            {
                              required: true,
                              message: 'required',
                            },
                          ],
                        })(
                          <Select
                            name="country"
                            placeholder="Select Country"
                            size="large"
                          >
                            {options.map((country) => (
                              <Option key={country} value={country.label}>
                                {country.label}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item>
                  <Button type="default" htmlType="submit" style={buttonStyle}>
                    Continue
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const WrappedCustomerForm = Form.create({ name: "customer" })(CustomerForm);

CustomerForm.propTypes = {
  final_search_form: PropTypes.object,
  queryParams: PropTypes.object,
  agentInformation: PropTypes.object,
  transaction_type: PropTypes.string,
  booking_customer_form: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    public_user_view_after_submit: state.form.public_user_view_after_submit,
    discount: state.route.discount,
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    user: state.route.USER_DETAILS,
    agentInformation: state.form.AgentInformation,
    transaction_type: state.code_config.transactionType,
    booking_customer_form: state.route.booking_customer_form,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedCustomerForm)
);
